export default "__VITE_ASSET__CPrP880H__"